import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { getLogger } from "../../utils/logger";
import { isString } from "../../utils/validators";
import { SETTER_ACTIONS } from "./types";
var log = getLogger("form");
/**
 * FormValueSetter is a special component that updates inner state of Form with
 * specified property/value pair. Used as a control button to unset single applied
 * property from the form by specifying its name an leaving value undefined.
 */ export var FormValueSetter = function(param) {
    var _param_action = param.action, action = _param_action === void 0 ? SETTER_ACTIONS.set : _param_action, children = param.children, name = param.name, onClick = param.onClick, submit = param.submit, value = param.value;
    return /*#__PURE__*/ _jsx("button", {
        className: "inline-block w-max cursor-pointer border-none bg-transparent",
        onClick: function() {
            if (onClick && name) {
                if (submit) {
                    log.info("Submit form. ".concat(name, ": ").concat(value));
                }
                onClick(action, name, value);
            }
        },
        type: "button",
        children: isString(children) ? children : /*#__PURE__*/ React.cloneElement(children, {
            "data-testid": action === SETTER_ACTIONS.set ? "value-setter-".concat(name) : "value-setter-".concat(name, "-").concat(value)
        })
    });
};

//# sourceMappingURL=FormValueSetter.js.map